import React, { useState } from 'react'
import { PortfolioCommonContainer } from '@components'
import { Box, Button, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { apiSearch } from '@store'
import { showToast } from '@utils'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'

const SearchInput = () => {
    const dispatch = useDispatch()
    const { portfolio } = useSelector((state) => state.portfolio)

    const initialState = {
        startdate: '',
        enddate: '',
        paymentdate: '',
        instrumenttype: 'forward',
        entrystatus: '',
        portfolio: '',
    }

    const [state, setState] = useState(initialState)

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        })
    }

    const handleDateChange = (name, value) => {
        setState({
            ...state,
            [name]: value ? value.format('YYYY-MM-DD') : ''
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const resp = await dispatch(apiSearch(state))
        if (resp.meta.requestStatus === 'fulfilled') {
        } else if (resp.meta.requestStatus === 'rejected') {
            showToast('error', resp.payload)
        } else {
            showToast('error', 'Something went wrong')
        }
    }

    const handleClear = () => {
        setState(initialState)
    }

    return (
        <PortfolioCommonContainer
            component="form"
            topic={'Search'}
            onSubmit={handleSubmit}
        >
            <Box className="flex flex-col gap-4">
                <Box className="flex gap-3">
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Portfolio
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.portfolio}
                            label="Portfolio"
                            onChange={handleChange}
                            name="portfolio"
                        >
                            {portfolio.map((item, index) => (
                                <MenuItem key={index} value={item.uuid}>
                                    {item.name}
                                </MenuItem>
                            ))}
                            <MenuItem value={'all'}>All</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Instrument Type
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.instrumenttype}
                            label="Instrument Type"
                            onChange={handleChange}
                            name="instrumenttype"
                        >
                            <MenuItem value={'forward'}>Forward</MenuItem>
                            {/* <MenuItem value={'options'}>Options</MenuItem> */}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Entry Status
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.entrystatus}
                            label="Entry Status"
                            onChange={handleChange}
                            name="entrystatus"
                        >
                            <MenuItem value={'new'}>New</MenuItem>
                            <MenuItem value={'pending'}>Pending</MenuItem>
                            <MenuItem value={'closed'}>Closed</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box className="flex gap-3 mb-2">
                    <FormControl fullWidth>
                        <DatePicker
                            label="Start Date"
                            format="DD/MM/YYYY"
                            value={state.startdate ? dayjs(state.startdate) : null}
                            onChange={(value) => handleDateChange('startdate', value)}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    placeholder: 'DD/MM/YYYY'
                                }
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <DatePicker
                            label="End Date"
                            format="DD/MM/YYYY"
                            value={state.enddate ? dayjs(state.enddate) : null}
                            onChange={(value) => handleDateChange('enddate', value)}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    placeholder: 'DD/MM/YYYY'
                                }
                            }}
                        />
                    </FormControl>
                </Box>
                </LocalizationProvider>
            </Box>
            <Box className="flex justify-end mt-2 gap-3">
                <Button
                    variant="outlined"
                    color="error"
                    sx={{
                        borderColor: '1px solid #EB6969',
                        color: '#EB6969',
                        fontSize: '14px',
                        '&:hover': {
                            borderColor: '1px solid #EB6969',
                            color: 'white',
                            backgroundColor: '#EB6969'
                        }
                    }}
                    onClick={handleClear}
                >
                    Clear
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    className="page-button"
                    sx={{
                        bgcolor: '#0b9cfd',
                        '&:hover': {
                            bgcolor: '#0b9cfd'
                        }
                    }}
                >
                    Search
                </Button>
            </Box>
        </PortfolioCommonContainer>
    );
}

export default SearchInput